import { graphql } from "~/gql";

export const NOTIFICATION_SUBSCRIPTION = graphql(/* GraphQL */ `
  subscription NewNotification {
    newNotification {
      id
      title
      type
      description
      matterId
      message
      isParent
    }
  }
`);
